<script lang="ts" setup>
import BrandReviewCard from '~/components/cards/BrandReviewCard.vue'
import JsonApiHelper from '~/helpers/json-api-helper'
import type { ReviewData } from '~/types/reviews'

const props = defineProps<{
  brandId: string
}>()

const messages = {
  failedToGetReviews: 'Не удалось получить отзывы.',
  noReviews: 'Нет отзывов.'
}

const { $apiHelper, $toast } = useNuxtApp()

const brandReviewsKey = computed(() => `brand-reviews-${props.brandId}`)

const { data: reviewsData, status: reviewsStatus } = await useLazyAsyncData(brandReviewsKey, loadReviewsData)

async function loadReviewsData (): Promise<ReviewData[]> {
  const params = { 'filter[brandId]': props.brandId, 'page[size]': 8 }

  try {
    const response = await $apiHelper.reviews.getReviews(params)
    const { data } = JsonApiHelper.denormalizeResponse(response)

    return data
  } catch (error) {
    console.error(error)

    $toast.error(messages.failedToGetReviews)

    throw error
  }
}
</script>

<template>
  <div class="brand-reviews">
    <div class="h2">
      Отзывы
    </div>

    <Preloader v-if="reviewsStatus === 'pending'" />
    <template v-else-if="reviewsStatus === 'success' && reviewsData">
      <Carousel v-if="reviewsData.length" class="!w-full">
        <div class="-ml-2 flex max-w-full items-stretch md:-ml-4">
          <div
            v-for="x in reviewsData"
            :key="x.id"
            class="flex-[0_0_90%] cursor-pointer pl-2 md:flex-[0_0_33.333333%] md:pl-4"
          >
            <BrandReviewCard :review-data="x" />
          </div>
        </div>
      </Carousel>
      <Notification v-else status="info">
        {{ messages.noReviews }}
      </Notification>
    </template>
    <template v-else>
      <Notification class="mb-4" status="error">
        {{ messages.failedToGetReviews }}
      </Notification>

      <a href="#" @click.prevent="refreshNuxtData('reviewsDataKey')">Повторить попытку</a>
    </template>
  </div>
</template>
